import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import FormCard from '../../../shared/components/custom/FormCard';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';

const p = partial('chat');
const s = partial('shared');

const AUTO_HIDE = ['', '2', '3', '5', '10'];
// Months; '' keeps messages
const RETENTION = ['', '3', '6', '12', '24'];

// The club's banned words (masked in chats and comments) and how many
// reports hide a chat message until it is reviewed
const ChatSettingsCard = () => {
  const [words, setWords] = useState('');
  const [autoHide, setAutoHide] = useState('');
  const [retention, setRetention] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Api.chat
      .getSettings()
      .then((settings) => {
        setWords((settings?.bannedWords || []).join('\n'));
        setAutoHide(
          settings?.autoHideReports ? String(settings.autoHideReports) : ''
        );
        setRetention(
          settings?.chatRetentionMonths
            ? String(settings.chatRetentionMonths)
            : ''
        );
      })
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await Api.chat.saveSettings({
        bannedWords: words
          .split('\n')
          .map((word) => word.trim())
          .filter(Boolean),
        autoHideReports: autoHide ? Number(autoHide) : 0,
        chatRetentionMonths: retention ? Number(retention) : 0,
      });
      toast.success(p('settingsSaved'));
    } catch (err) {
      toast.error(err || p('settingsSaveERROR'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormCard
      title={p('moderationSettings')}
      className="mb-3"
      actions={
        <Button
          size="sm"
          color="primary"
          className="mb-0"
          disabled={saving}
          onClick={save}
        >
          {s('save')}
        </Button>
      }
    >
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label for="banned-words">{p('bannedWords')}</Label>
            <Input
              id="banned-words"
              type="textarea"
              rows={6}
              value={words}
              onChange={(e) => setWords(e.target.value)}
            />
            <small className="text-muted">{p('bannedWordsInfo')}</small>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="auto-hide">{p('autoHideReports')}</Label>
            <Input
              id="auto-hide"
              type="select"
              value={autoHide}
              onChange={(e) => setAutoHide(e.target.value)}
            >
              {AUTO_HIDE.map((count) => (
                <option key={count || 'off'} value={count}>
                  {count ? p('autoHideAfter', { count }) : p('autoHideOff')}
                </option>
              ))}
            </Input>
            <small className="text-muted">{p('autoHideReportsInfo')}</small>
          </FormGroup>
          <FormGroup>
            <Label for="retention">{p('retention')}</Label>
            <Input
              id="retention"
              type="select"
              value={retention}
              onChange={(e) => setRetention(e.target.value)}
            >
              {RETENTION.map((months) => (
                <option key={months || 'keep'} value={months}>
                  {months
                    ? p('retentionMonths', { count: months })
                    : p('retentionKeep')}
                </option>
              ))}
            </Input>
            <small className="text-muted">{p('retentionInfo')}</small>
          </FormGroup>
        </Col>
      </Row>
    </FormCard>
  );
};

export default ChatSettingsCard;
